export default "__VITE_ASSET__CvJ$eEQ3__"